import { ColorPickerPosition } from 'views/BulkPurchaseDevices/subcomponents/ColorPicker/ColorSlider';
import { dangerColor, primaryColor, blackColor } from 'assets/jss/material-dashboard-pro-react';

const colorPickerStyles = () => ({
	colorDot: ({ isLightColor, color, unavailable }) => ({
		width: '100%',
		height: ' 100%',
		borderRadius: '50%',
		boxSizing: 'border-box',
		border: isLightColor ? `solid 1px ${blackColor}` : '0px',
		backgroundColor: color,
		opacity: 1,
		cursor: unavailable ? 'no-drop' : 'pointer',
		pointerEvents: unavailable ? 'none' : 'all',
	}),

	colorDotWrapper: ({ selected, separator, size, position, unavailable }) => ({
		display: 'inline-block',
		boxSizing: 'border-box',
		borderRadius: '50%',
		overflow: 'hidden',
		margin: position === ColorPickerPosition.HORIZONTAL ? `0 ${separator}px` : `${separator}px 0`,
		width: size,
		height: size,
		border: selected && `solid 1px ${primaryColor[0]}`,
		transition: 'border 0.4s',
		padding: selected ? '3px' : '4px',
		cursor: unavailable ? 'no-drop' : 'pointer',
		pointerEvents: unavailable ? 'none' : 'all',
	}),

	sliderWrapper: () => ({
		margin: '10px 0 0 0',
	}),

	crossLine: {
		position: 'relative',
		width: '100%',
		height: '100%',
		left: '0',
		bottom: '9px',
		borderTop: '3px solid',
		borderColor: dangerColor[0],
		transform: 'skewY(-45deg)',
	},
});

export default colorPickerStyles;
